import { useCallback } from 'react';

import TextInput from 'src/components/TextInput';

type TextInputProps = {
  field: UCM.DynamicFieldType;
  value: ({ value: string } & string) | undefined;
  onChange: (field: UCM.DynamicFieldType, value: { value: string }) => void;
};

export default function TextField({
  field,
  onChange,
  value,
  ...others
}: TextInputProps) {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      onChange?.(field, { value });
    },
    [onChange, field],
  );

  return (
    <TextInput
      {...others}
      fullWidth
      value={value?.value || value}
      label={field.label}
      onChange={handleChange}
    />
  );
}
